import token from 'common/lib/util/token';
import { initialize, LDOptions, LDUser } from 'ldclient-js';

interface CustomMetadata {
  channel: string;
  idEnterprises: string[];
  idOrgs: string[];
  orgs: string[];
}

const launchdarklyKey = window.launchdarklyKey;
const user: LDUser = {
  key: token.getMyId() || 'notLoggedIn',
  anonymous: !token.getMyId(),
};
const options: LDOptions = {
  bootstrap: 'localStorage',
};

export const ldclient = initialize(launchdarklyKey, user, options);

export const updateUserInfo = (metadata: CustomMetadata) => {
  const extendedUser: LDUser = {
    ...user,
    custom: {
      ...metadata,
    },
  };

  ldclient.identify(extendedUser);
};



// WEBPACK FOOTER //
// ./app/common/lib/ldclient.ts